import React, { useEffect, useMemo } from 'react';

import { dataUrlParaBlob } from '../../utils/arquivoDataUrl';

// Abre em nova aba um PDF que está guardado como data URL (issue #325).
//
// Substitui o `<a href="data:application/pdf..." target="_blank">` que havia
// em quatro telas: navegador baseado em Chromium e Firefox bloqueiam navegar
// para `data:`, então aqueles links não abriam absolutamente nada — sem aba,
// sem aviso, sem erro na tela. Com Blob URL o mesmo arquivo abre normalmente.
//
// Recebe `className`/`style` porque cada tela já tinha a sua aparência de
// botão e não é assunto desta correção mexer nisso.
function BotaoAbrirPdf({ dataUrl, className, style, title, children }) {
  const url = useMemo(
    () => (dataUrl ? URL.createObjectURL(dataUrlParaBlob(dataUrl)) : ''),
    [dataUrl]
  );

  useEffect(
    () => () => {
      if (url) URL.revokeObjectURL(url);
    },
    [url]
  );

  if (!dataUrl) return null;

  return (
    <button
      type="button"
      className={className}
      style={style}
      title={title}
      onClick={() => window.open(url, '_blank', 'noopener')}
    >
      {children}
    </button>
  );
}

export default BotaoAbrirPdf;
